import React from 'react';
import { CheckCircle, ArrowRight, Shield, AlertTriangle, FileText, Users, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../styles/Servicos.css';

const Servicos = () => {
  const navigate = useNavigate();

  const services = [
    {
      category: 'Consultoria',
      icon: <FileText size={24} />,
      items: [
        'Consultoria Especializada em Segurança Contra Incêndios',
        'Planeamento de Sistemas de Proteção e Prevenção',
        'Elaboração de Projetos de Sistema de Proteção e Prevenção de Incêndios',
        'Assessoria Técnica para Conformidade Regulamentar'
      ],
    },
    {
      category: 'Análise e Auditoria',
      icon: <AlertTriangle size={24} />,
      items: [
        'Análise Detalhada de Riscos de Incêndio',
        'Auditoria Completa de Segurança Contra Incêndios',
        'Avaliação de Conformidade com Normas Nacionais',
        'Inspeção de Equipamentos e Sistemas de Segurança'
      ],
    },
    {
      category: 'Brigadas de Incêndio',
      icon: <Users size={24} />,
      description: 'Alocação de equipas de bombeiros profissionais em regime 24h/7 para garantia contínua de normas de proteção.',
      items: [
        'Piquetes 24h/7 com bombeiros profissionais',
        'Atuação em áreas de elevado risco (indústrias, mineração, shoppings)',
        'Implementação e fiscalização de normas de proteção contra incêndios',
        'Resposta imediata e coordenação com equipas internas'
      ],
    },
    {
      category: 'Planos de Emergência',
      icon: <Shield size={24} />,
      items: [
        'Elaboração de Planos de Emergência Personalizados',
        'Desenvolvimento de Planos de Evacuação Eficientes',
        'Simulacros e Testes de Procedimentos de Emergência',
        'Sistemas de Alerta e Comunicação de Emergência'
      ],
    },
     {
      category: 'Manutenção',
      icon: <Wrench size={24} />,
      items: [
        'Manutenção de Extintores',
        'Manutenção de Sistemas de deteção e Alarme de Incêndio',
        'Manutenção de Sistemas de Hidrantes e Sprinklers',
        'Inspeção e Manutenção de Equipamentos de Combate a Incêndios',
      ],
    },
  ];

  return (
    <div className="servicos-page">
      <section className="page-hero" aria-label="Cabeçalho serviços">
        <div className="container">
          <span className="section-subtitle">Soluções Completas</span>
          <h1 className="section-title">Serviços Especializados</h1>
          <p className="section-description">Consultoria, análise de risco, brigadas profissionais e manutenção certificada. Conformidade regulamentar e proteção integral para o seu património.</p>
        </div>
      </section>
      <section className="servicos-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Proteção e Segurança</span>
            <h2>Serviços Especializados</h2>
            <p>
              Soluções completas em segurança contra incêndios e gestão de emergências, 
              com expertise técnica e conformidade regulamentar em Moçambique.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card" style={{ animationDelay: `${index * 0.08}s` }}>
                <div className="service-header">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.category}</h3>
                </div>
                {service.description && <p className="service-description">{service.description}</p>}
                <ul className="service-list">
                  {service.items.map((item, itemIndex) => (
                    <li key={itemIndex}>
                      <CheckCircle size={18} aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="cta-container">
            <button
              className="btn-primary"
              onClick={() => navigate('/contatos')}
              aria-label="Solicitar consultoria em segurança contra incêndios"
            >
              Solicitar Consultoria
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servicos;